import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

    static targets = ['popup', 'label', 'phoneBtn']

    static values = {
        autoShowLabel: { type: Boolean, default: false },
        labelDelay:    { type: Number,  default: 30000 },
        trackUrl:      { type: String,  default: '' },
    }

    connect() {
        this._isOpen     = false
        this._labelTimer = null
        this._isTrackingCooldown = false

        if (this.autoShowLabelValue) {
            this._scheduleLabelExpand()
        }
    }

    disconnect() {
        this._clearLabelTimer()
    }

    toggle(event) {
        event.stopPropagation()
        this._isOpen ? this.close() : this.open(event)
    }

    open(event) {
        event?.stopPropagation()
        if (this._isOpen) return

        this._isOpen = true
        this.popupTarget.classList.add('call-button-widget__popup--open')
        this.popupTarget.setAttribute('aria-hidden', 'false')

        if (this.hasPhoneBtnTarget) {
            this.phoneBtnTarget.setAttribute('aria-expanded', 'true')
        }

        this._collapseLabel()
        this._clearLabelTimer()
    }

    close() {
        if (!this._isOpen) return

        this._isOpen = false
        this.popupTarget.classList.remove('call-button-widget__popup--open')
        this.popupTarget.setAttribute('aria-hidden', 'true')

        if (this.hasPhoneBtnTarget) {
            this.phoneBtnTarget.setAttribute('aria-expanded', 'false')
        }
    }

    closeOnOutsideClick(event) {
        if (!this._isOpen) return
        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    track(event) {
        if (!this.trackUrlValue || this._isTrackingCooldown) {
            console.log('Request blocked by missing URL or cooldown')
            return;
        }

        this._isTrackingCooldown = true;
        setTimeout(() => {
            this._isTrackingCooldown = false;
        }, 10000);

        console.log('Firing Axios POST to', this.trackUrlValue)

        axios.post(this.trackUrlValue)
            .then(res => console.log('Success:', res.data))
            .catch(error => console.error('Tracking failed', error));
    }

    onKeydown({ key }) {
        if (key === 'Escape' && this._isOpen) {
            this.close()
            this.hasPhoneBtnTarget && this.phoneBtnTarget.focus()
        }
    }

    _scheduleLabelExpand() {
        this._clearLabelTimer()
        this._collapseLabel()

        this._labelTimer = setTimeout(() => {
            if (!this.hasLabelTarget || this._isOpen) return

            this.labelTarget.classList.add('call-button-widget__label--expanded')
            this.labelTarget.setAttribute('aria-hidden', 'false')
            this.labelTarget.removeAttribute('tabindex')
        }, this.labelDelayValue)
    }

    _collapseLabel() {
        if (!this.hasLabelTarget) return

        this.labelTarget.classList.remove('call-button-widget__label--expanded')
        this.labelTarget.setAttribute('aria-hidden', 'true')
        this.labelTarget.setAttribute('tabindex', '-1')
    }

    _clearLabelTimer() {
        if (this._labelTimer) {
            clearTimeout(this._labelTimer)
            this._labelTimer = null
        }
    }
}
